import React, { useEffect, useRef } from 'react'
import Accordion from 'react-bootstrap/Accordion';
import "./faqs.scss"
import Navbar from '../landing/header/Navbar';
import { Link } from 'react-router-dom';



const Faqs = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    return (
        <>
            <Navbar />
            <section className="faqs-detail">
                <img src="\assets\faqs-bg.png" alt="img" className='img-fluid faqs-bg' />
                <div className="custom-container">
                    <div className="main-heading">
                        <div className="upper-breadcrumb">
                            <Link to="/">Home</Link>
                            <span>/</span>
                            <Link to="/faqs" style={{ color: "#013159" }}>Faqs</Link>
                        </div>
                        <h4>Frequently Asked questions</h4>
                        <p>Last Update: January 06, 2025</p>
                    </div>
                    <div className="faqs-parent">
                        <div className="faqs-heading">
                            <h6>General Information</h6>
                        </div>
                        <Accordion >
                            <Accordion.Item eventKey="0">
                                <Accordion.Header> What is Tasks?</Accordion.Header>
                                <Accordion.Body>
                                    Tasks is a decentralized platform that allows users to create, complete, and reward tasks using blockchain technology. The platform ensures transparency, fairness, and trust through community governance and smart contracts.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header> How does Tasks work?</Accordion.Header>
                                <Accordion.Body>
                                    Tasks operates as a decentralized platform for creating, completing, and rewarding tasks. Here's a simplified overview of the process:
                                    <ol>
                                        <li><span>Task Creation:</span> Users create tasks, specifying requirements, deadlines, and reward amounts.</li>
                                        <li><span>Task Completion:</span> Participants complete tasks and submit proof of completion.</li>
                                        <li><span>Review Process:</span> The task creator reviews the submission and decides if it meets the requirements.</li>
                                        <li><span>Dispute Resolution:</span>  If the task creator does not accept the submission, the participant can initiate a dispute. The case is then reviewed by randomly selected members on DOP Oracles.</li>
                                        <li><span>Reward Distribution:</span>  Once the task submission is verified and approved, the task winner can immediately claim the reward.</li>
                                    </ol>

                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="2">
                                <Accordion.Header> What types of tasks can I post on Tasks?</Accordion.Header>
                                <Accordion.Body>
                                    You can post a wide variety of tasks, including digital services (e.g., software development, design, marketing), physical tasks (e.g., custom artwork, delivery services), or even unique requests (e.g., event planning, personal assistance).
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="3">
                                <Accordion.Header> Can I be both a task creator and a participant?</Accordion.Header>
                                <Accordion.Body>
                                    Yes, you can be both a task creator and a participant on the platform. As a task creator, you can post tasks and manage their completion, while as a participant, you can join and complete tasks created by others. However, you cannot participate in tasks you have created to ensure fairness and transparency.
                                </Accordion.Body>
                            </Accordion.Item>
                            <div className="faqs-heading mt-5">
                                <h6>For Task Creators</h6>
                            </div>
                            <Accordion.Item eventKey="4">
                                <Accordion.Header> How do I create a task?</Accordion.Header>
                                <Accordion.Body>
                                    <ol>
                                        <li>Click on <span>Connect Wallet</span> in the upper right corner and connect your wallet.</li>
                                        <li>Click the <span>Create Task</span> button, then fill out the task details.</li>
                                        <li>Click the <span>Create Task</span> button at the bottom, and confirm the transaction in your wallet.</li>
                                    </ol>
                                    The task will be visible to the community, and participants can start submitting their work.

                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="5">
                                <Accordion.Header> Can I edit a task after it’s posted?</Accordion.Header>
                                <Accordion.Body>
                                    Yes, you can edit certain aspects of a task, but only if there are no participants yet. Once a task has participants, it cannot be edited to ensure fairness. Please use the preview feature before posting to make sure everything is correct.
                                    <p className='newpara'>If your task has no participants, you'll see an "Edit Task" button on the task page. Click this button to make your changes. You can edit the following fields:</p>
                                    <ul>
                                        <li>Task Requirements</li>
                                        <li>Delivery Format</li>
                                        <li>Additional Requests</li>
                                        <li>Category</li>
                                        <li>Service Type (including country and city for physical tasks)</li>
                                        <li>Time Zone</li>
                                        <li>Task End Date</li>
                                    </ul>
                                </Accordion.Body>
                            </Accordion.Item>
                            {/* <Accordion.Item eventKey="6">
                                <Accordion.Header> How is the reward distributed?</Accordion.Header>
                                <Accordion.Body>
                                    Once the task is successfully completed and verified by the task creator, the task completer can claim the reward and withdraw it to their wallet. A small fee (5%) is allocated for the buyback and burn of $DOP and $TASK tokens.

                                </Accordion.Body>
                            </Accordion.Item> */}
                            <Accordion.Item eventKey="7">
                                <Accordion.Header> What if I am not satisfied with the submitted proof?</Accordion.Header>
                                <Accordion.Body>
                                    If you’re not satisfied with the proof submitted by participants, you can choose not to accept their submissions. In the event of a dispute, it will be resolved through a community voting process on DOP Oracles to ensure a fair outcome. If the Oracles also reject the submission, you will receive a refund of 95% of the reward you offered. The remaining 5% is allocated for the buyback and burn of $DOP and $TASK tokens.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="12">
                                <Accordion.Header>Is there a time limit for tasks?</Accordion.Header>
                                <Accordion.Body>
                                    Yes, tasks have a default maximum duration of 30 days. This helps prevent excessively long waiting periods and ensures timely task completion. If no submissions are received within the initial 30 days, the task creator has two options:
                                    <ul>
                                        <li>Extend the task duration for an additional 30 days at no extra cost.</li>
                                        <li>Reclaim the reward amount directly to their wallet.</li>
                                    </ul>
                                </Accordion.Body>
                            </Accordion.Item>
                            <div className="faqs-heading mt-5">
                                <h6>For Task Participants</h6>
                            </div>
                            <Accordion.Item eventKey="8">
                                <Accordion.Header> How do I participate in a task?</Accordion.Header>
                                <Accordion.Body>
                                    Browse the available tasks on the “Explore Tasks” page. When you find a task you are interested in, you click on the “Participate” button on the task page to show your intent. You will receive a unique secret code to use in your proof of work. Once you complete the task, submit your proof of work along with the secret code you were given.

                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="9">
                                <Accordion.Header> How is my submission verified?</Accordion.Header>
                                <Accordion.Body>
                                    Your submission is verified by either the task creator or the community through a decentralized voting process conducted on DOP Oracles. The decision is based on the quality and completeness of your submission, including the unique secret code provided as part of your proof of work.

                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="10">
                                <Accordion.Header> What happens if my submission is not accepted by the task creator?</Accordion.Header>
                                <Accordion.Body>
                                    If your submission is not accepted by the task creator, you can open a dispute. The dispute will be resolved through a transparent voting process conducted by DOP Oracles. This ensures a fair and reliable decision based on majority consensus. Note: Opening a dispute involves a fixed fee of $15 in USDT.

                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="11">
                                <Accordion.Header> When will I receive my reward?</Accordion.Header>
                                <Accordion.Body>
                                    Once your submission is accepted by the task creator or the DAO (on DOP Oracles) has determined you as the winner in a dispute resolution, you can claim the reward with a click of a button, and it will be transferred to your connected wallet immediately.

                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </div>
                    <div className="faqs-parent">
                        <div className="faqs-heading">
                            <h6>Platform & Technical Questions</h6>
                        </div>
                        <Accordion >
                            <Accordion.Item eventKey="0">
                                <Accordion.Header> Which blockchain does Tasks use?</Accordion.Header>
                                <Accordion.Body>
                                    Currently, Tasks operates on the Arbitrum blockchain, ensuring secure and transparent transactions. In the future, we plan to integrate Tasks with other networks for improved scalability and reduced transaction costs.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header> What cryptocurrencies are supported on Tasks?</Accordion.Header>
                                <Accordion.Body>
                                    Tasks primarily supports payments in ETH, TASK, USDT, USDC, LINK, PEPE, UNI, DOP, ORC, and WBTC. In addition, we are continuously exploring additional cryptocurrency options based on user demand and platform updates.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="2">
                                <Accordion.Header> How do I connect my wallet to the platform?</Accordion.Header>
                                <Accordion.Body>
                                    You can connect your cryptocurrency wallet (e.g., MetaMask) directly through the platform. Click the <span className='forboldtext'>Connect Wallet</span> button at the upper right corner and follow the prompts to link your wallet securely.

                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="3">
                                <Accordion.Header> Is there a fee for using the platform?</Accordion.Header>
                                <Accordion.Body>
                                    Yes, there are two types of fees on Tasks:
                                    <ul>
                                        <ol>
                                            <li><span className='forboldtext'>Task Completion Fee:</span>  A small fee (5%) is added on top of each task reward and allocated for the buyback and burn of $DOP and $TASK tokens. For example, if you set a reward of $100, you'll pay $105 in total, with $100 going to the task completer and $5 allocated for the buyback and burn of DOP and Tasks native tokens.
                                            </li>
                                            Task creators can receive a 40% discount on platform fees by paying with $TASK tokens. In this case, the platform fee reduces to 3%. For example, with a $100 reward:
<ul >
    <li>When paying with $TASK tokens: Pay $103 total ($100 reward + $3 platform fee)
    </li>
    <li>When paying with other tokens: Pay $105 total ($100 reward + $5 platform fee)</li>
</ul>
                                            <li> <span className='forboldtext'>Dispute Fee:</span> When initiating a dispute, the fee structure depends on the task's reward value:</li>
                                        </ol>
                                    </ul>
                                    <ul className='formarginul'>
                                        <li>For tasks with rewards less than $1,000 (Mini Dispute): <br></br>
                                            Fixed Cost: $15 per claim<br></br>
                                            Additional Cost: 0.5% of deal size (deducted from the reward
                                            )
                                        </li>
                                        <li>For tasks with rewards of $1,000 or more (Regular Dispute):<br></br>
                                            Fixed Cost: $400 per claim<br></br>
                                            Additional Cost: 0.25% of deal size (deducted from the reward)
                                        </li>
                                    </ul>
                                </Accordion.Body>
                            </Accordion.Item>
                            <div className="faqs-heading mt-5">
                                <h6>Governance & Community</h6>
                            </div>
                            <Accordion.Item eventKey="4">
                                <Accordion.Header> What is a DAO, and how does it work on Tasks?</Accordion.Header>
                                <Accordion.Body>
                                    A DAO (Decentralized Autonomous Organization) is a community-governed entity that operates without central authority. On Tasks, the DAO operates through DOP Oracles, and helps resolve disputes between task creators and completers, ensuring a transparent and fair process.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="5">
                                <Accordion.Header> What happens if there’s a dispute?</Accordion.Header>
                                <Accordion.Body>
                                    In case of a dispute between a task creator and a participant, the participant can open a dispute and the matter is escalated to the DAO on DOP Oracles. To ensure impartiality, three Oracles will be randomly selected by the system to participate in the dispute resolution. The Oracles’ decision is final, and will be received within 48 hours.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="6">
                                <Accordion.Header> What are the steps a task goes through toward completion, and what does each task status mean?</Accordion.Header>
                                <Accordion.Body>
                                    <ol>
                                        <li><span>Live:</span> The task is active on the platform, accepting participants, and the due date has not yet passed, due date is set by the task creator.</li>
                                        <li><span>Under Review:</span> The task creator has 48 hours to review the submissions to decide on the winner.</li>
                                        <li><span>In Dispute Period:</span>  If a participant disagrees with the decision of the task creator, they can open a dispute within 24 hours.</li>
                                        <li><span>In Voting Period:</span> A dispute has been opened, and the case is under review by the DAO on DOP Oracles for 48 hours. The Oracles vote to determine the winner, and the result is finalized once the voting period ends.</li>
                                        <li><span>Dispute Resolved:</span> The Oracles have concluded the voting process, and a resolution has been reached to determine the winner.</li>
                                        <li><span>Completed:</span> The winner has successfully claimed the reward, and the task is officially marked as completed.</li>
                                    </ol>
                                </Accordion.Body>
                            </Accordion.Item>

                        </Accordion>
                    </div>
                    <div className="faqs-parent">
                        <div className="faqs-heading">
                            <h6>Security & Privacy</h6>
                        </div>
                        <Accordion >
                            <Accordion.Item eventKey="0">
                                <Accordion.Header> Is my personal information secure on the platform?</Accordion.Header>
                                <Accordion.Body>
                                    Tasks uses blockchain to minimize data collection and ensure user privacy. Your wallet address is used for transactions, and no personal data is required to create or complete tasks. However, you have the option to add your email on your profile page if you wish to receive updates on relevant tasks that match your preferences and expertise.
                                    Mind that information you provide in the task creation form will be publicly visible, so you might want to avoid including sensitive information.

                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header> Are smart contracts safe on Tasks?</Accordion.Header>
                                <Accordion.Body>
                                    Yes, all tasks and reward distributions are managed through secure smart contracts on the blockchain. This ensures that transactions are automated, transparent, and tamper-proof.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="2">
                                <Accordion.Header> How can I protect myself from scams or fraudulent tasks?</Accordion.Header>
                                <Accordion.Body>
                                    Always review the task details and creator’s profile before participating. The community voting and verification process also help ensure fairness, but please exercise caution, especially when interacting with new or unknown task creators.
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </div>





                    <div className="faqs-parent">
                        <div className="faqs-heading">
                            <h6>Disputes and Resolutions</h6>
                        </div>
                        <Accordion>
                            <Accordion.Item eventKey="10">
                                <Accordion.Header>What are the different types of disputes on Tasks?</Accordion.Header>
                                <Accordion.Body>
                                    Tasks offers two types of disputes based on the task's reward value:
                                    <ol>
                                        <li>
                                            Mini Dispute (Tasks {"<"} $1,000)
                                            <ul className=''>

                                                <li>Fixed Cost: $15 per claim</li>

                                                <li>Additional Cost: 0.5% of deal size (deducted from the reward)</li>
                                                <li>Oracles Involved: 3</li>
                                                <li>Claims: 1 file per side:</li>
                                            </ul>
                                            <ol>
                                                <ul className='formarginli'>
                                                    <li>Task Creator: The file is their task description.</li>
                                                    <li>Task Completer: The file is the one they submitted for the task.</li>
                                                </ul>
                                            </ol>
                                            <ul>
                                                <li>Ideal for lower-value tasks requiring swift, cost-effective resolution.</li>
                                            </ul>
                                        </li>

                                        <li>


                                            Regular Dispute (Tasks ≥ $1,000)

                                            <ul className=''>

                                                <li>Fixed Cost: $400 per claim</li>

                                                <li>Additional Cost: 0.25% of deal size (deducted from the reward)</li>
                                                <li>Oracles Involved: 15</li>
                                                <li>Claims: 2 files per side - one file as in the mini-dispute, and an additional file as follows:</li>
                                            </ul>
                                            <ol>
                                                <ul className='formarginli'>
                                                    <li>Task Creator: A file containing an explanation why they rejected the submission.
                                                    </li>
                                                    <li>Task Completer: Additional proof to show that they have indeed completed the task according to the Creator's requests.</li>
                                                </ul>
                                            </ol>
                                            <ul>
                                                <li>
                                                    Designed for high-value tasks requiring comprehensive evaluation.
                                                </li>
                                            </ul>
                                        </li>
                                    </ol>


                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="0">
                                <Accordion.Header> How do I open a dispute?</Accordion.Header>
                                <Accordion.Body>
                                    If your submission is not accepted by the task creator, you have 24 hours to open a dispute. The dispute process varies based on the task's reward value:
                                    <p className='newpara'>
                                        For tasks with rewards less than $1,000 (Mini Dispute):
                                    </p>
                                    <ul><li>Cost: $15 per claim + 0.5% of deal size (deducted from the reward)</li>
                                        <li>3 Oracles involved</li>
                                        <li>You submit 1 claim file: the file you submitted for the task</li>
                                    </ul>
                                    For tasks with rewards of $1,000 or more (Regular Dispute):
                                    <ul>
                                        <li>Cost: $400 per claim + 0.25% of deal size (deducted from the reward)</li>
                                        <li>15 Oracles involved</li>
                                        <li>You submit 2 claim files: the file you submitted for the task, and additional proof showing you completed the task according to the creator's requests</li>
                                    </ul>
                                    To open a dispute, click <span className='forbold'>Create a Dispute</span> on the task page. After paying the required fee, your case will be sent to DOP Oracles. The Oracles will review your case and vote on their decision within 48 hours. The result will then be displayed on your Task page.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header> What is DOP Oracles?</Accordion.Header>
                                <Accordion.Body>
                                    DOP Oracles is a decentralized platform that bridges the gap between Web2 and Web3 by providing reliable data validation and dispute resolution. It connects verified participants (Oracles) who answer questions about real-world events, creating a trustworthy source of information for blockchain applications. <br />
                                    DOP Oracles is used for dispute resolution in Tasks. If a task completer disagrees with the task creator's decision to reject their submission, they can open a dispute and escalate the issue to DOP Oracles. The oracle community votes on the dispute, providing an impartial resolution.

                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="2">
                                <Accordion.Header> Is there a fee to open a dispute?</Accordion.Header>
                                <Accordion.Body>
                                    Yes, there is a fee to open a dispute, which varies based on the task's reward value:
                                    For tasks with rewards less than $1,000 (Mini Dispute):
                                    <ul>
                                        <li>Fixed Cost: $15 per claim</li>
                                        <li>Additional Cost: 0.5% of deal size (deducted from the reward)</li>
                                    </ul>
                                    For tasks with rewards of $1,000 or more (Regular Dispute):
                                    <ul>
                                        <li>Fixed Cost: $400 per claim</li>
                                        <li>Additional Cost: 0.25% of deal size (deducted from the reward)</li>
                                    </ul>
                                    <p className='newpara'>
                                        This fee structure helps ensure that disputes are raised only for legitimate reasons and compensates the DOP Oracles for their service in resolving conflicts.
                                    </p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="3">
                                <Accordion.Header> What happens if the dispute is resolved in favor of the task completer?</Accordion.Header>
                                <Accordion.Body>
                                    If the dispute is resolved in favor of the task completer, they will be able to claim 95% of the reward. The remaining 5% is allocated for the buyback and burn of $DOP and $TASK tokens.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="4">
                                <Accordion.Header> What happens if the dispute is resolved in favor of the task creator?</Accordion.Header>
                                <Accordion.Body>
                                    If the dispute is resolved in favor of the task creator, they will be able to claim 95% of the reward they had originally offered. The remaining 5% is allocated for the buyback and burn of $DOP and $TASK tokens.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="5">
                                <Accordion.Header>What happens if no votes are cast by DOP Oracles?</Accordion.Header>
                                <Accordion.Body>
                                    If no votes are cast by DOP Oracles during the dispute resolution process, a second round of voting is initiated. If the task creator has selected a winner and no votes are cast in the second round, the selected winner will receive the full reward. Conversely, if the task creator has not selected a winner and no votes are cast in the second round, the task creator will receive the full reward.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="6">
                                <Accordion.Header> What happens if multiple participants receive equal votes during DOP Oracles voting?</Accordion.Header>
                                <Accordion.Body>
                                    If multiple participants in the same task open a dispute and receive the same number of votes, the last vote cast will be removed repeatedly until a winner is determined.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="7">
                                <Accordion.Header> How long does the dispute resolution process take?</Accordion.Header>
                                <Accordion.Body>
                                    Once a dispute is opened, DOP Oracles have 48 hours to vote on the case. Once the voting is concluded, the result will be displayed in the Task page.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="8">
                                <Accordion.Header> Can I appeal a decision made by DOP Oracles?</Accordion.Header>
                                <Accordion.Body>
                                    No. The Oracle’s decision is final and cannot be appealed.
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </div>
                    <div className="faqs-parent">
                        <div className="faqs-heading">
                            <h6>Support & Contact</h6>
                        </div>
                        <Accordion >
                            <Accordion.Item eventKey="0">
                                <Accordion.Header> How can I get help if I encounter an issue?</Accordion.Header>
                                <Accordion.Body>
                                    If you need assistance, you can contact us directly at <a href="mailto: support@tasks.market">support@tasks.market</a>, visit <a href="https://tasks.market/contact-us" target='_blank'>tasks.market/contact-us</a>, or follow <a href="https://x.com/Tasks_on_Chain" target='_blank'>@tasks_on_chain</a> on X (Twitter) for updates and support.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header> How can I provide feedback or suggest improvements?</Accordion.Header>
                                <Accordion.Body>
                                    We welcome user feedback! You can share your suggestions by reaching out to us at <a href="mailto: support@tasks.market">support@tasks.market</a> or by visiting <a href="https://tasks.market/contact-us" target='_blank'>tasks.market/contact-us</a> to help shape the future of the platform.

                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </div>

                </div>
            </section>
        </>
    )
}

export default Faqs
